module.exports = __webpack_public_path__ + "dhl-logo@2x.png?c27cb7763aa5373bc08d0d89e6651052";


//////////////////
// WEBPACK FOOTER
// ./src/assets/dhl-logo@2x.png
// module id = 1032
// module chunks = 0